/**
 * One field with kind pills (`company/ux/patterns.md` § 3; CU-869fmjzrh S2, generalised from Cars, CU-869fmhmx8):
 * a filter whose values come in mutually exclusive kinds is one field; its menu opens on the kind in use (else the
 * default), every kind keeps its pill (an empty one says `none yet`), and picking in another kind replaces the current
 * one, with a note. Pure and alias-free.
 *
 * `current` = `{ kind, on }`: the kind in use and whether anything is picked.
 */

/** `Rome, Milan` · `Rome, Milan +1` */
export const shortList = (labels, max = 2) => labels.slice(0, max).join(', ') + (labels.length > max ? ` +${labels.length - max}` : '')

/** The pill the menu opens on */
export const menuTab = (current, defaultTab) => (current?.on ? current.kind : defaultTab)

/** `[{ value, label, empty, note }]` in `order`; `counts[kind] === 0` = nothing to pick there yet (null = loading) */
export function kindPills(order, labels, counts = {}) {
	return order.map(value => {
		const empty = counts[value] === 0
		return { value, label: labels[value], empty, note: empty ? 'none yet' : null }
	})
}

/** Inside the menu, looking at another kind while one is in use */
export function replaceNote(current, tab, labels) {
	return current?.on && current.kind !== tab ? `One kind at a time: picking here replaces ${shortList(labels)}.` : null
}
